import { generateUUID } from './lib/uuid.js';
import ifEmoji from 'if-emoji';
import { createForm } from './lib/simple-form.js';

function dataBlock($qblock) {
    const current_block = {
        id: $qblock.dataset.id,
        questions: [...$qblock.querySelectorAll('.question')].map($question => {
            return {
                id: $question.dataset.id,
                answer: null
            }
        })
    };
    return current_block;
}

function initDB($qblock) {
    const current_block = dataBlock($qblock);
    const db_json = window.localStorage.getItem('qblocks_db');
    let db = {};
    if (!db_json) {
        db = {
            user: generateUUID(),
            qblocks: {},
            active: current_block.id
        };
    } else {
        db = JSON.parse(db_json);
    }
    db.active = current_block.id;
    if (!db.qblocks[db.active]) {
        db.qblocks = { ...db.qblocks, [current_block.id]: current_block };
    }
    return db;
}

export function saveDB(db) {
    window.localStorage.setItem('qblocks_db', JSON.stringify(db));
}


function getAnswer(db, id) {
    return db.qblocks[db.active].questions.find(question => question.id === id && question.answer);
}

function renderQBlock(db, $qblock) {
    const $questions = $qblock.querySelectorAll('.question');
    const $progress = document.querySelector('.progress');
    let progress = 0;
    $questions.forEach($el => {
        if (getAnswer(db, $el.dataset.id)?.answer) {
            progress = progress + 1;
            $el.classList.add('answered');
            $el.classList.remove('unanswered');
        }
    });
    $progress.textContent = `${progress < $questions.length ? progress + 1 : 1} / ${$questions.length}`;
}

function renderFieldsInitial(db, $qblock) {
    const $questions = $qblock.querySelectorAll('.question');
    $questions.forEach($question => {
        const answer = getAnswer(db, $question.dataset.id)?.answer;
        if (answer) {
            $question.querySelectorAll('input').forEach($field => {
                if ($field.value === answer) {
                    $field.checked = true;
                }
            })
        }
    });
}

function renderResults(data, variant = 'normal') {
    const $qblock = document.querySelector('.qblock');
    const answer_urls = {
        yes: $qblock.dataset.yes_url,
        maybe: $qblock.dataset.maybe_url,
        no: $qblock.dataset.no_url,
    };
    return Object.entries(data.analyzed).map(([_uuid, row], idx) => {
        const my_answer = row.my_answer;
        console.log('my_answer', my_answer, 'is_completed', data.is_completed);
        let { result, total } = row;
        let highest = Object.entries(result).reduce((highest, [answer, count]) => {
            return Math.max(highest, count);
        }, 0);
        console.log('total', total, 'highest', highest);
        const result_ordered = Object.entries(result);
        const orderby = ['yes', 'maybe', 'no'];
        result_ordered.sort(([a_answer, _a_count], [b_answer, _b_count]) => {
            return orderby.indexOf(a_answer) - orderby.indexOf(b_answer);
        });
        console.log('result ordered', result_ordered);
        let sub_total_percentage = 0;

        const question_text = document.querySelector(`.question[data-id="${row.question_id}"] .question-text`)?.textContent;

        if (variant === 'normal') {
            return (
                `<div class="question-result${idx === 0 ? ' active' : ''}">
                    <p class="question-text">${question_text}</p>
                    ${result_ordered.map(([answer, count], answer_idx) => {
                    const is_my_answer = answer === my_answer;
                    const raw_percentage = total > 0 ? (count / total) * 100 : 0;
                    let percentage = Math.round(raw_percentage);
                    if (total > 0) {
                        sub_total_percentage = sub_total_percentage + percentage;
                        if (answer_idx + 1 === result_ordered.length) {
                            percentage = percentage + (100 - sub_total_percentage);
                        }
                    }
                    return `<div class="answer-wrapper answer-${answer}"><img src="${answer_urls[answer]}" /><div class="result-count${is_my_answer ? ' my-answer' : ''}">${percentage}%</div></div>`;
                }).join('')}
                </div>`
            );
        } else {
            return (
                `<div class="question-result${idx === 0 ? ' active' : ''} bar-chart-variant">
                    <p class="question-text">${question_text}</p>
                    ${result_ordered.map(([answer, count], answer_idx) => {
                    const is_my_answer = answer === my_answer;
                    const raw_percentage = total > 0 ? (count / total) * 100 : 0;
                    let percentage = Math.round(raw_percentage);
                    if (total > 0) {
                        sub_total_percentage = sub_total_percentage + percentage;
                        if (answer_idx + 1 === result_ordered.length) {
                            percentage = percentage + (100 - sub_total_percentage);
                        }
                    }
                    const percentage_bar = `<span class="bar-percentage">${percentage}%</span><div class="percentage-bar" style="--factor: ${highest > 0 ? (count / highest) : 0};"></div>`;
                    return `<div class="answer-wrapper answer-${answer}"><img src="${answer_urls[answer]}" /><div class="result-count${is_my_answer ? ' my-answer' : ''}">${percentage_bar}</div></div>`;
                }).join('')}
                </div>`
            );
        }
    }).join('');
}

function calculatePercentages(row, my_answer) {
    const total = Object.entries(row.result).reduce((total, [answer, count]) => {
        return total + count;
    }, 1);
    const result_ordered = Object.entries(row.result);
    const orderby = ['yes', 'maybe', 'no'];
    result_ordered.sort(([a_answer, a_count], [b_answer, b_count]) => {
        return orderby.indexOf(a_answer) - orderby.indexOf(b_answer);
    });
    let sub_total_percentage = 0;
    return result_ordered.map(([answer, count], answer_idx) => {
        if (answer === my_answer) {
            count = count + 1;
        }
        const raw_percentage = (count / total) * 100;
        let percentage = Math.round(raw_percentage);
        sub_total_percentage = sub_total_percentage + percentage;
        if (answer_idx + 1 === result_ordered.length) {
            percentage = percentage + (100 - sub_total_percentage);
        }
        return { answer, percentage };
    });
}

function renderIntermediate($el, id, results, db, next) {
    $el.classList.add('active');
    const $percentage = $el.querySelector('.intermediate-percentage');
    const my_answer = getAnswer(db, id)?.answer;
    console.log(db, id, my_answer);
    const $response_text = $el.querySelector('.intermediate-response-text .' + my_answer);
    $response_text.classList.add('active');
    $percentage.innerHTML = calculatePercentages(results.analyzed[id], my_answer).find(result => result.answer === my_answer).percentage + '%';
    const $continue = $el.querySelector('.intermediate-continue');
    $continue.addEventListener('click', event => {
        event.preventDefault();
        $el.classList.remove('active');
        next();
    }, { once: true });

}

function registerResults($root = document, result_date, skip = false) {
    const $results = $root.querySelectorAll('.question-result');
    const $progress = $root.querySelector('.progress');
    const $progress_wrapper = $root.querySelector('.progress-wrapper');
    const $continue = $root.querySelector('.continue');
    const $result_date = $root.querySelector('.result-time time');
    const $thank_you = $root.querySelector('.thank-you');
    const $qblock = $root.querySelector('.qblock');
    $result_date.textContent = result_date;

    if (skip) {
        $thank_you.classList.add('active');
        $qblock.classList.remove('done');
        $qblock.classList.add('finished');
        $progress_wrapper.classList.add('hideme');
        return;
    }

    let active = 0;

    $continue.addEventListener('click', event => {
        active = active + 1;
        $results.forEach(($result, idx) => {
            if (idx === active) {
                $result.classList.add('active');
                $progress.textContent = `${active < $results.length ? active + 1 : 1} / ${$results.length}`;
            } else {
                $result.classList.remove('active');
            }
        });
        if (active === $results.length) {
            $thank_you.classList.add('active');
            $qblock.classList.remove('done');
            $qblock.classList.add('finished');
            $progress_wrapper.classList.add('hideme');
        }
    });
}


function handleAnswer(db, question_id, answer) {
    db.qblocks[db.active].questions = db.qblocks[db.active].questions.map(question => {
        if (question_id === question.id) {
            return { ...question, answer };
        }
        return question;
    });
    return db;
}

function handleSubmit(config, data) {
    console.log('submit', config, data);
    const request_body = data;
    request_body.meta = config.meta;
    return fetch(config.form.action, {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json',
        },
        body: JSON.stringify(request_body)
    });
}

function fetchResults(id, user) {
    return fetch(`/wp-json/qblock/v1/qblock/${id}/session/${user}`, {
        method: 'GET',
    });
}

function isFinished(db) {
    return !(db.qblocks[db.active].questions.find(question => !question.answer));
}

export async function registerQBlockResults($root = document) {
    const $el = $root.querySelector('.qblock-completed-content');
    if (!$el) {
        return;
    }
    let db = initDB($el);

    $root.querySelector('body').classList.add('loading');
    const results_json = await fetchResults($el.querySelector('.qblock').dataset.id, db.user);
    const results = await results_json.json();
    $root.querySelector('body').classList.remove('loading');
    const $result = $el.querySelectorAll('.result');

    const result_strings = Object.fromEntries(Object.entries(results.analyzed).map(([k, v], idx) => {
        return [k, renderResults({
            qblock: results.qblock,
            user: results.user,
            is_completed: results.is_completed,
            analyzed: {
                [k]: v
            }
        }, db, idx % 2 === 0 ? 'normal' : 'bar')];
    }));

    console.log(result_strings);

    $result.forEach($result => {
        $result.querySelector('.data').innerHTML = result_strings[$result.dataset.id];
    })
}

export async function registerQBlock($root = document) {
    const $el = $root.querySelector('.qblock');
    if (!$el) {
        return;
    }
    const $form = $el.querySelector('form.qblock-form');
    if (!$form) {
        return;
    }
    const $questions = $el.querySelectorAll('.question');
    const config = JSON.parse($form.dataset.config);
    let db = initDB($el);

    $root.querySelector('body').classList.add('loading');
    const results_json = await fetchResults(db.active, db.user);
    const results = await results_json.json();
    $root.querySelector('body').classList.remove('loading');

    const time_now = new Date(); // todo
    const days = time_now.getDate().toString();
    const months = (time_now.getMonth() + 1).toString();
    const hours = time_now.getHours().toString();
    const minutes = time_now.getMinutes().toString();
    const days_padded = days.length < 2 ? '0' + days : days;
    const months_padded = months.length < 2 ? '0' + months : months;
    const hours_padded = hours.length < 2 ? '0' + hours : hours;
    const minutes_padded = minutes.length < 2 ? '0' + minutes : minutes;
    const result_date = `${days_padded}.${months_padded}.${time_now.getFullYear()} um ${hours_padded}:${minutes_padded}`;

    renderQBlock(db, $el);
    renderFieldsInitial(db, $el);

    setNotoForEmojiIfNecessary($el);

    function handleFinished(skip = false) {
        const $result = $el.querySelector('.result');
        $result.querySelector('.data').innerHTML = renderResults(results);
        const $progress = $root.querySelector('.progress');
        $progress.textContent = `1 / ${$questions.length}`;
        registerResults($root, result_date, skip);
        $el.classList.add('done');
        registerEmailButton(document);
    }

    if (isFinished(db)) {
        handleFinished();
    }

    $el.addEventListener('change', event => {
        if (event.target !== $form && event.target.form !== $form) {
            return;
        }
        db = handleAnswer(db, event.target.dataset.id, event.target.value);
        console.log({ db });
        saveDB(db);
        handleSubmit(config, {
            user: db.user,
            qblock: db.active,
            question_id: event.target.dataset.id,
            answer: event.target.value
        });
        const $current_question = $el.querySelectorAll('.question.unanswered')[0];
        const $intermediate_result = $current_question.querySelector('.intermediate-result');
        const id = $current_question.dataset.id;
        renderIntermediate($intermediate_result, id, results, db, () => {
            renderQBlock(db, $el);
            if (isFinished(db)) {
                handleFinished(true);
            }
        });
    });
}

function setNotoForEmojiIfNecessary($qblock) {
    const $questionEmojis = $qblock.querySelectorAll('.question-emoji');
    $questionEmojis.forEach($el => {
        //console.log($el.textContent);
        if (!ifEmoji($el.textContent)) {
            $el.classList.add('use-noto-emoji');
        } else {
            $el.classList.remove('use-noto-emoji');
        }
    });
}

function registerEmailButton($root = document) {
    const $email_button = $root.querySelector('.email-button');
    if (!$email_button) {
        return;
    }
    const $email_section = $root.querySelector('.email-register');
    const $thank_you = $root.querySelector('.thank-you');

    const $form = $root.querySelector('form#email-register-form');
    const $form_els = [...$form.elements];
    const $submit_email = $root.querySelector(".submit-email");
    const config = JSON.parse($form.dataset.config);

    // const db_json = window.localStorage.getItem('qblocks_db');
    // const db = JSON.parse(db_json);
    const $qblock = $root.querySelector('.qblock');
    let db = initDB($qblock);
    if (db.qblocks[db.active].email_sent) {
        $email_button.classList.add('none');
        $root.querySelector('.thank-you-registered').classList.add('active');
        $email_section.classList.remove('active');
    } else if (db.email) {
        fetch(config.form.action, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
            },
            body: JSON.stringify({
                email: db.email,
                compliance: "on",
                qblock_ids: [db.active],
            })
        })
        db.qblocks[db.active].email_sent = true;
        saveDB(db);
        $email_button.classList.add('none');
        $root.querySelector('.thank-you-registered').classList.add('active');
        $email_section.classList.remove('active');
    }

    $email_button.addEventListener('click', event => {
        event.preventDefault();
        $email_section.classList.add('active');
        $thank_you.classList.remove('active');
    });

    console.log('$form', $form);

    // directly change the UI after submit
    $form.addEventListener('submit', event => {
        const $invalid_els = $form_els.filter($el => !$el.validity.valid);
        if ($invalid_els.length !== 0) {
            console.warn($invalid_els[0])
            document.querySelector(`.form-error[data-for=${$invalid_els[0].id}]`).classList.add('show');
            $invalid_els[0].parentNode.classList.add('show-error');
            event.preventDefault();
            return;
        }

        // @todo temp
        event.preventDefault();

        $submit_email.classList.add('waiting');
        $submit_email.textContent = "Einen Moment!";

        const form_data = new FormData(event.target);
        console.log({ config });
        for (const entry of form_data.entries()) {
            console.log(entry);
        }

        const unregistered_qblock_ids = Object.entries(db.qblocks)
            .filter(([_id, qblock]) => !qblock.email_sent)
            .map(([id, _qblock]) => id);

        const request_body = {
            ...Object.fromEntries(
                [...form_data.entries()]
                    .filter(([name, value]) => name !== "qblock_id")
            ), qblock_ids: unregistered_qblock_ids
        };

        unregistered_qblock_ids.forEach(id => {
            db.qblocks[id].email_sent = true;
        });
        db.email = request_body.email;
        saveDB(db);

        request_body.meta = config.meta;
        fetch(config.form.action, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
            },
            body: JSON.stringify(request_body)
        }).then(response => {
            $root.querySelector('.thank-you-registered').classList.add('active');
            $email_section.classList.remove('active');
        });
    });

    $form_els.forEach($el => {
        $el.addEventListener('invalid', event => {
            console.log('invalid', event);
        });
        $el.addEventListener('input', event => {
            document.querySelector(`.form-error[data-for=${$el.id}]`).classList.remove('show');
            $el.parentNode.classList.remove('show-error');
            console.log('input', event);
        });
        $el.addEventListener('focus', event => {
            if ($el.id) {
                document.querySelector(`.form-error[data-for=${$el.id}]`).classList.remove('show');
                $el.parentNode.classList.remove('show-error');
            }
            console.log('input', event);
        });
    });
}